import React from "react";
import DefaultLayout from "../Layouts/DefaultLayout";
import StoreList from "../Components/Layout/StoreList";
import { useStoreContext } from "../Contexts/StoreContext";

const Stores = () => {
    const { currentStore } = useStoreContext();

    return (
        <DefaultLayout showHeader={currentStore}>
            <StoreList />
        </DefaultLayout>
    );
};

export default Stores;